import React from "react";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css"; // Import the CSS module
interface Tile {
  title: string;
  description: string;
  path: string;
}

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  // Define each tile with a title, description, and path for navigation
  const tiles: Tile[] = [
    {
      title: "Add Property",
      description: "Start your journey & add your property here",
      path: "/main/add-property",
    },
    {
      title: "View Properties",
      description: "View a list of all your properties",
      path: "/main/properties",
    },
    {
      title: "Rent Management",
      description:
        "Mark who has paid rent this month, who hasn't and a timeline of their payments",
      path: "/main/tenant-payments",
    },
    {
      title: "View Docs",
      description:
        "Coming soon... Upload tenant leases, insuranace docs, mortgage payment docs and so much more",
      path: "/main/dashboard",
    },
    // { title: 'Revenue', description: 'View revenue stats', path: '/revenue' },
    // {
    //   title: 'Analytics',
    //   description: 'Check traffic and performance',
    //   path: '/analytics',
    // },
    {
      title: "New Features",
      description:
        "We are continously working on new features to better enhance your property management",
      path: "/settings",
    },
    // {
    //   title: "Settings",
    //   description: "Manage account settings",
    //   path: "/settings",
    // },
  ];

  return (
    <div className="bg">
      {/* Header */}
      <h1 className="dashboard-header">Dashboard</h1>

      {/* Quick Action Tiles */}
      <div className="tiles-container">
        {tiles.map((tile, index) => (
          <div key={index} className="tile" onClick={() => navigate(tile.path)}>
            <h2>{tile.title}</h2>
            <p>{tile.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
